export default
{
    path:'/unit',
    name:'unit',
    component:()=>import('../view/unit')
}



// WEBPACK FOOTER //
// ./src/router/unitRouter.js